import { createFileRoute } from "@tanstack/react-router";

import { Centered } from "@/components/ui/container";
import { apiUtils } from "@/context/query";

export const Route = createFileRoute("/_auth/_app/accessions/newv2")({
  beforeLoad: async ({ context: { user } }) => {
    if (
      !user.hasRole([
        "blis_org_tech",
        "blis_lab_assistant",
        "blis_lab_tech",
        "blis_lab_manager",
      ])
    ) {
      throw new Error("Unauthorized");
    }
  },
  async loader() {
    await Promise.all([
      apiUtils.subjects.search.ensureData({ query: "", take: 10 }),
      apiUtils.orgs.guessOrg.ensureData({}),
      apiUtils.orgs.primaryOrgsList.ensureData(),
    ]);
  },
  errorComponent: ({ error }) => <Centered>{error.message}</Centered>,
});
